<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Quotations',
  data () {
    return {
    }
  },
  mounted () {
    this.$store.dispatch('quotation/reset')
    this.$store.dispatch('systemSetting/loadSystemSettings')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/quotations/index.vue